import shortSellModal from './../../components/Dialogs/confirmationModal';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { parse } from "json2csv";
import { API_URL } from "../../../config";
import { isTokenValid, setInputFilter } from "../../utils/util";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import * as XLSX from 'xlsx';
import { GENERATE_REPORT , AUTO_SUGGEST_SYMBOLS , GET_SYMBOL_PRICE ,GET_INSTRUMENT_ID } from './../../store/actions.type';
import {debounce} from "debounce";

import {
  getJWTFromStorage,
  removeJWTFromStorage,
  saveJWTToStorage
} from '@/api/localStorage';

export default {
  name: "ImportHoldings",
  mixins: [validationMixin],
  components: { FontAwesomeIcon, shortSellModal },
  data() {
    return {
      selectedBroker: 5,
      brokers: [
        // { value: 1, text: "5Paisa" },
        // { value: 2, text: "ICICI Direct" },
        // { value: 3, text: "Sharekhan" },
        { value: 5, text: "PortfolioSmith Format" },
        { value: 4, text: "Zerodha Tradebook" }

      ],
      csv_file: null,
      res: null,
      stocksymbol:'',
      fileUploadBtnTxt: "Import Holdings",
      showdeletefilebtn:false,
      transactionBtnText: "Choose File",
      recommFileBtnTxt: "Upload Recommendations",
      modelFileBtnTxt: "Upload Model Portfolio",
      addNewmodalShow: false,
      newStock:{symbol:"",quantity:"",buyDate:"",buyPrice:"",tradeType:"Buy"},
      showImportTransactions: false,
      showShortSellError: false,
      shortSellErrorMessage: "",
      userPortfolioFiles: new FormData(),
      showGenerateReportButton:false,
      loaded: false,
      isLoading: false,
      fullPage: true,
      admin: false,
      sample: "sample_csv_files/sample_upload_file.csv",
      client: "",
      brokerOrModelForRecomm: "No Recommendation",
      brokerOrModelForPortfolio: "Model Portfolio",
      selectedModelPortfolio: 0,
      selectedRecomm: 0,
      date: "date",
      buyPrice: null,
      holdingsJson: [],
      instrumentsJson: [],
      holdingsJsonCount: null,
      brokerPortfolioData: null,
      recommData: null,
      reco: [{ id: 0, name: "No Recommendation" }],
      portfo: [{ id: 0, name: "Model Portfolio" }],
      selectedPortfolioId: 0,
      selectedRecommId: 0,
      validTable: false,
      validRow: false,
      cash: 0,
      suggestions: [],
      sugCurIndex: 0,
      doAutoSuggest: false,
      symIndex: "",
      showSubmitBtn: false,
      msUrl:
        "https://marketsmithindia.com/gateway/simple-api/ms-india/instr/",
      msAuth:
        "ms-auth=3990+MarketSmithINDUID-Web0000000000+MarketSmithINDUID-Web0000000000+3+190910230055+2134291654",
      maxDate: moment().format("YYYY-MM-DD"),
      minDate: "1900-09-05",
      sessionIdleErrorMsg: "Session is expired. Please login again",
      transactionData: {
        BestExclusions: null,
        WorstExclusions: null,
        BestWinners: null,
        WorstLosers: null
      },
      allowShortSell:0
    };
  },

  computed: {
    ...mapGetters("addholdings", {
      portfolio: "portfolio",
      alphaScopeData: "alphaScopeData"
    }),

    iconPlus() {
      return faPlus;
    },
    iconTrash() {
      return faTrash;
    },
    isReportAvailable() {
      if (this.alphaScopeData) return true;
      else return false;
    },
	  userData () {
		  return this.$store.state.authentication.user;
	  },
    isRedirectedGuestBrokerUrl(){
      return (localStorage.getItem('utmParams') == 'utm_source=ARGuest')?true:false;
    }
  },

  created () {
    window.scrollTo(0, 0);

	this.client = this.userData.name;
  },

  mounted() {
    // Mounted Methods should comes here
    setInputFilter(this.$refs.uintTextBox, function(value) {
      return /^\d*$/.test(value);
    });
    if (localStorage.getItem("is_admin") == "true") {
      this.admin = true;
    } else {
      this.admin = false;
    }

    let portfolioJson = JSON.parse(localStorage.getItem("portfolios"));
    this.brokerPortfolioData = portfolioJson;
    for (var i in this.brokerPortfolioData)
      this.portfo.push(this.brokerPortfolioData[i]);

    let recommJson = JSON.parse(localStorage.getItem("recs"));
    this.recommData = recommJson;
    for (var i in this.recommData) this.reco.push(this.recommData[i]);

    if (
      this.portfolio &&
      JSON.parse(this.portfolio.HoldingsData) &&
      JSON.parse(this.portfolio.HoldingsData.length > 0)
    ) {
      this.holdingsJson = JSON.parse(this.portfolio.HoldingsData);
      this.client = this.portfolio.client;
      this.selectedRecomm = this.portfolio.SelectedRecomm;
      this.selectedRecommId = this.portfolio.SelectedRecomm;
      this.selectedPortfolioId = this.portfolio.SelectedModelPortfolio;
      this.selectedModelPortfolio = this.portfolio.SelectedModelPortfolio;
      this.cash = this.portfolio.Cash;
      this.brokerOrModelForRecomm = this.portfolio.BrokerOrModelForRecomm;
      this.brokerOrModelForPortfolio = this.portfolio.BrokerOrModelForPortfolio;
    }

    // For Edit
    // if (this.$route.path === "/ImportHoldings/Edit") {
    // if (
    //   JSON.parse(localStorage.getItem("HoldingsData")) &&
    //   JSON.parse(localStorage.getItem("HoldingsData").length > 0)
    // ) {
    //   this.holdingsJson = JSON.parse(localStorage.getItem("HoldingsData"));
    //   this.client = localStorage.getItem("client");
    //   this.selectedRecomm = localStorage.getItem("SelectedRecomm");
    //   this.selectedRecommId = localStorage.getItem("SelectedRecomm");
    //   this.selectedPortfolioId = localStorage.getItem("SelectedModelPortfolio");
    //   this.selectedModelPortfolio = localStorage.getItem(
    //     "SelectedModelPortfolio"
    //   );
    //   this.cash = localStorage.getItem("Cash");
    // }
    // }
    this.validateHoldings();
  },

  validations: {
    csv_file: {
      required
    }
  },

  watch: {},

  methods: {
    ...mapActions("addholdings", {
      setAlphaScopeData: "setAlphaScopeData",
      setEnableReport: "setEnableReport",
      setPortfolio: "setPortfolio",
      setTransactionData: "setTransactionData",
      generateReport: GENERATE_REPORT,
      autoSuggestSymbols:AUTO_SUGGEST_SYMBOLS,
      getSymbolPrice:GET_SYMBOL_PRICE,
      getInstrumentId:GET_INSTRUMENT_ID
    }),
    ...mapActions("portfolioreport", {
      setTab: "setTab"
    }),

    addStockModalClick(){
      this.addNewmodalShow = !this.addNewmodalShow
      this.newStock = {symbol:"",quantity:"",buyDate:"",buyPrice:"",tradeType:"Buy"};
  },

  addNewStock()
  {
    if (this.validNewStock() === true) {
      this.holdingsJson.push({
        Symbol: this.newStock.symbol,
        Quantity: this.newStock.quantity,
        BuyDate: this.newStock.buyDate,
        BuyPrice:this.newStock.buyPrice,
        SlNo: this.holdingsJson.length + 1,
      });
      this.addNewmodalShow = false;
      this.newStock = {symbol:"",quantity:"",buyDate:"",buyPrice:"",tradeType:"Buy"};
      this.validTable = true;
      this.validRow = true;
    }
  },

  validateSymbolResponsive(symbol,show = true, isFile = false) {
    if (symbol !== "" && symbol !== null) {
      this.$toastr.removeByName('symbol-error');
      if (
        symbol.length > 0 &&
        this.doAutoSuggest == true
      ) {
        this.autoSuggest(symbol);
      } else {
        this.suggestions = [];
      }
      return false;
    } else {
      this.newStock.buyPrice = "";
      this.newStock.buyDate= "";
      if (show) {
        if (!isFile) this.$toastr.removeByType("error");
        var symbolError = this.$toastr.Add({
          name: "symbol-error", // this is give you ability to use removeByName method
          msg: "Symbol is mandatory.", // Toast Message
          type: "error", // Toast type,
          position: "toast-top-full-width", //toast-top-full-width
          clickClose: true, // Click Close Disable
          timeout: 0,
          showCloseButton:true,
        });
      }

      return true;
    }
  },

  validateQuantityResponsive(quantity, show = true, isFile = false) {
    var pattern = new RegExp("^[1-9]\\d*$");
    if (
      quantity !== "" &&
      quantity !== null &&
      quantity % 1 === 0 &&
      quantity !== "0" &&
      typeof parseInt(quantity) === "number"
    ) {
      this.$toastr.removeByName("quantity-error");
      return false;
    }
    else {
      if (show) {
        if (!isFile) this.$toastr.removeByType("error");
        var quantityError = this.$toastr.Add({
          name: "quantity-error", // this is give you ability to use removeByName method
          msg:
            "Quantity is mandatory <br> - Must be a positive integer number <br> - Decimals not Allowed <br> - Quantity should not be Zero", // Toast Message
          type: "error", // Toast type,
          position: "toast-top-full-width",
          clickClose: true, // Click Close Disable
          timeout: 0,
          showCloseButton:true,
        });
      }
      return true;
    }
  },

  updateBuyDateResponsive(value) {
    if (
      moment(moment(value).utcOffset("+05:30").format("YYYY-MM-DD"), "YYYY-MM-DD", true).isValid()
    ) {
      let val = moment(value).utcOffset("+05:30").format("YYYY-MM-DD");
      this.newStock.buyDate = val;
      this.updatePriceByDateResponsive(val);
      $(`#PopupBuyDate`).removeClass('errorCellClass');
    } else {
      this.$toastr.removeByType("error");
      var priceError = this.$toastr.Add({
        name: "price-error", // this is give you ability to use removeByName method
        msg: "Purchase Date & Buy Price is Mandatory", // Toast Message
        type: "error", // Toast type,
        position: "toast-top-full-width",
        clickClose: true, // Click Close Disable
        timeout: 0,
        showCloseButton:true,
      });
      this.newStock.buyPrice = "";
    }
    this.suggestions = [];
    this.doAutoSuggest = false;
  },

  updateSuggestionResponsive(resultsArr, key) {
    this.newStock.instrumentId = resultsArr.instrumentId;
    this.newStock.symbol=resultsArr.symbol;
    this.suggestions = [];
    if (this.newStock.buyPrice != "") {
      this.updatePriceByDateResponsive(this.newStock.buyPrice);
    }
    this.doAutoSuggest = false;
  },

  async getPriceAPIResponsive(date, instrumentId) {
    if (instrumentId !== "") {
      date = moment(date, "YYYY-MM-DD")
        .utcOffset("+05:30")
        .format("DD/MM/YYYY");
      await this.getSymbolPrice(
          this.msUrl +
            "getPriceForSymbol.json?instId=" +
            instrumentId +
            "&transDate=" +
            date +
            "&splitAdjust=" +
            "&" +
            this.msAuth
        )
        .then(response => {
          if (!response.data && response.data.status != 200) {
            //this.$toastr.e('Upload failed. Please check your CSV file and then try again.');
            this.$toastr.e(
              "Unable to retrieve price, kindly enter manually."
            );
          } else {
            this.newStock.buyPrice = parseFloat(response.data.Price).toFixed(2);
            this.$toastr.removeByName('price-error');
            return response;
          }
        });
    } else {
      this.newStock.buyPrice = "";
      this.$toastr.e("Unable to retrieve price, kindly enter manually.");
    }
    this.suggestions = [];
  },

  changeTradeTypeResponsive(event) {
    if (
      this.newStock.quantity != "" &&
      this.newStock.quantity != undefined &&
      this.newStock.quantity != null
    ) {
      if (event.target.value == "1") {
        this.newStock.quantity = `-${this.newStock.quantity}`;
      } else {
        this.newStock.quantity = this.newStock.quantity.replace(
          "-",
          ""
        );
      }
    } else {
      this.$toastr.e(
        "Please add a valid Quantity before changing the Trade Type"
      );
      return false;
    }
  },

  updatePriceByDateResponsive(date) {
    let instrumentId = this.newStock.instrumentId;
    if (instrumentId != undefined) {
      let instrumentId = this.newStock.instrumentId;
      this.getPriceAPIResponsive(date, instrumentId);
    } else {
        this.newStock.buyPrice = "";
    }
    this.suggestions = [];
  },

  validNewStock()
  {
    if(this.addNewmodalShow)
    {
      if (!this.validateSymbolResponsive(this.newStock.symbol) && !this.validateQuantityResponsive(this.newStock.quantity)&&
      !this.validatePriceResponsive(this.newStock.buyPrice)&& this.newStock.symbol!="" && this.newStock.quantity!=""&& this.newStock.buyPrice!=""&& this.newStock.buyDate!="")
      {
        return true;
      }

      else false;

    }
    else false;


  },
  updateJsonResponsive: debounce( function(event, key){
    if (key == "Quantity") {
      $(`#PopupQuantity`).removeClass('errorCellClass')
      if(this.newStock.quantity.includes("-")){
        this.newStock.quantity = `-${event.target.value}`;
      }else {
      this.newStock.quantity = event.target.value;
      }
    }
    if (key != "Symbol") {
      this.suggestions = [];
      this.doAutoSuggest = false;
    } else {
      this.newStock.symbol=event.target.value;
      this.doAutoSuggest = true;
      $(`#PopupSymbol`).removeClass('errorCellClass')
    }
    if(key == 'BuyDate')
    {
      $(`#PopupBuyDate`).removeClass('errorCellClass');
    }
    let validateSymbol = !this.validateSymbolResponsive(
      this.newStock.symbol
    );
    let validatePrice = !this.validatePriceResponsive(
      this.newStock.buyPrice,
    );
    let validateQuantity = !this.validateQuantityResponsive(
      this.newStock.quantity,
    );
    let validDate = this.newStock.buyDate != "";

    if (key == "Symbol") {
      this.validRow =
        !this.validateSymbolResponsive(this.newStock.symbol) &&
        validatePrice &&
        validateQuantity &&
        validDate;
        this.$toastr.removeByName('quantity-error');
      // this.validTable =
      //   !this.validateSymbol(this.holdingsJson[index][key], index) &&
      //   validatePrice &&
      //   validateQuantity &&
      //   validDate;
    }
    if (key == "BuyPrice") {
      this.validRow =
        !this.validatePriceResponsive(this.newStock.buyPrice) &&
        validateSymbol &&
        validateQuantity &&
        validDate;
      // this.validTable =
      //   !this.validatePrice(this.holdingsJson[index][key], index) &&
      //   validateSymbol &&
      //   validateQuantity &&
      //   validDate;
    }
    if (key == "Quantity") {
      this.validRow =
        !this.validateQuantityResponsive(this.newStock.quantity) &&
        validateSymbol &&
        validatePrice &&
        validDate;
      // this.validTable =
      //   !this.validateQuantity(this.holdingsJson[index][key], index) &&
      //   validateSymbol &&
      //   validatePrice &&
      //   validDate;
    }
  }, 500),

    dateDMYtoYMD(date) {
      return moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
      },
    openShortSellError(errorMessage) {
      this.shortSellErrorMessage = errorMessage;
      this.showShortSellError = true;
    },

    validateHoldings(show = false) {
      var obj = this.holdingsJson;
      if (this.holdingsJson.length == 0) {
        this.validTable = false;
        this.validRow = true;
        return true;
      }

      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          var val = obj[key];
          let validateSymbol = !this.validateSymbol(
            val["Symbol"],
            key,
            true,
            show
          );
          let validatePrice = !this.validatePrice(
            val["BuyPrice"],
            key,
            true,
            show
          );
          let validateQuantity = !this.validateQuantity(
            val["Quantity"],
            key,
            true,
            show
          );
          let validDate = val["BuyDate"] != null && val["BuyDate"] != "";
          if (show && !validDate) {
            var priceError = this.$toastr.Add({
              name: "price-error", // this is give you ability to use removeByName method
              msg: "Purchase Date & Buy Price is Mandatory", // Toast Message
              type: "error", // Toast type,
              position: "toast-top-full-width",
              clickClose: true, // Click Close Disable
              timeout: 0,
              showCloseButton:true,
            });
          }
          if (
            !validateSymbol ||
            !validatePrice ||
            !validateQuantity ||
            !validDate
          ) {
            this.validRow = false;
            this.validTable = false;
            return false;
          }
        }
      }
      this.validRow = true;
      this.validTable = true;
      return true;
    },

    validatePriceResponsive(price, show = true, isFile = false) {
      //price = parseFloat(price)
      if (price === "" || price === null) {
        if (show) {
          if (!isFile) this.$toastr.removeByType("error");
          var priceError = this.$toastr.Add({
            name: "price-error", // this is give you ability to use removeByName method
            msg: "Buy Price is Mandatory", // Toast Message
            type: "error", // Toast type,
            position: "toast-top-full-width",
            clickClose: true, // Click Close Disable
            timeout: 0,
            showCloseButton:true,
          });
        }
        return true;
      } else if (price >= 0 && typeof parseFloat(price) === "number") {
         this.$toastr.removeByName("price-error");
        return false;
      } else {
        if (show) {
          this.$toastr.removeByType("error");
          var priceError = this.$toastr.Add({
            name: "price-error", // this is give you ability to use removeByName method
            msg: "Buy Price cannot be less than 0, please input the Buy Price of the stock", // Toast Message
            type: "error", // Toast type,
            position: "toast-top-full-width",
            clickClose: true, // Click Close Disable
            timeout: 0,
            showCloseButton:true,
          });
        }
        return true;
      }
    },

    validateSymbol(symbol, index, show = true, isFile = false) {
      this.stocksymbol = symbol.length
      if (symbol !== "" && symbol !== null) {
        this.$toastr.removeByName('symbol-error');
        if (
          symbol.length > 1 &&
          this.doAutoSuggest == true &&
          this.symIndex == index
        ) {
          this.sugCurIndex = index;
          this.autoSuggest(symbol);
        } else {
          this.suggestions = [];
        }
        return false;
      } else {
        this.holdingsJson[index]["BuyPrice"] = "";
        this.holdingsJson[index]["BuyDate"] = "";
        if (show) {
          if (!isFile) this.$toastr.removeByType("error");
          var symbolError = this.$toastr.Add({
            name: "symbol-error", // this is give you ability to use removeByName method
            msg: "Symbol is mandatory.", // Toast Message
            type: "error", // Toast type,
            position: "toast-top-full-width", //toast-top-full-width
            clickClose: true, // Click Close Disable
            timeout: 0,
            showCloseButton:true,
          });
        }

        return true;
      }
    },

    changeCash(e) {
      if (e.target.value.trim() == "") {
        this.cash = 0;
      } else {
        this.cash = e.target.value;
      }
    },

    async autoSuggest(symbol) {
      await this.autoSuggestSymbols(
          this.msUrl +
            "srch.json?text=" +
            symbol +
            "&lang=en&listID=-1&ver=2&" +
            this.msAuth
        )
        .then(response => {
          if (!response.data && response.data.status != 200) {
            this.suggestions = [];
            this.$toastr.e(
              "Upload failed. Please check your CSV file and then try again."
            );
          } else {
            this.suggestions = response.data.response.results;
            return response;
          }
        });
    },

    updateSuggestion(index, resultsArr, key) {
      this.holdingsJson[index][key] = resultsArr.symbol;
      this.instrumentsJson[resultsArr.symbol] = resultsArr.instrumentId;
      this.suggestions = [];
      if (this.holdingsJson[index]["BuyPrice"] != "") {
        this.updatePriceByDate(index, this.holdingsJson[index]["BuyDate"]);
      }
      this.doAutoSuggest = false;
    },

    validateQuantity(quantity, key, show = true, isFile = false) {
      var pattern = new RegExp("^[1-9]\\d*$");
      if (
        quantity !== "" &&
        quantity !== null &&
        quantity % 1 === 0 &&
        quantity !== "0" &&
        typeof parseInt(quantity) === "number"
      ) {
        this.$toastr.removeByName("quantity-error");
        return false;
      } else {
        if (show) {
          if (!isFile) this.$toastr.removeByType("error");
          var quantityError = this.$toastr.Add({
            name: "quantity-error", // this is give you ability to use removeByName method
            msg:
              "Quantity is mandatory <br> - Must be a positive integer number <br> - Decimals not Allowed <br> - Quantity should not be Zero", // Toast Message
            type: "error", // Toast type,
            position: "toast-top-full-width",
            clickClose: true, // Click Close Disable
            timeout: 0,
            showCloseButton:true,
          });
        }
        return true;
      }
    },

    validatePrice(price, key, show = true, isFile = false) {
      //price = parseFloat(price)
      if (price === "" || price === null) {
        if (show) {
          if (!isFile) this.$toastr.removeByType("error");
          var priceError = this.$toastr.Add({
            name: "price-error", // this is give you ability to use removeByName method
            msg: "Buy Price is Mandatory", // Toast Message
            type: "error", // Toast type,
            position: "toast-top-full-width",
            clickClose: true, // Click Close Disable
            timeout: 0,
            showCloseButton:true,
          });
        }
        return true;
      } else if (price >= 0 && typeof parseFloat(price) === "number") {
         this.$toastr.removeByName("price-error");
        return false;
      } else {
        if (show) {
          this.$toastr.removeByType("error");
          var priceError = this.$toastr.Add({
            name: "price-error", // this is give you ability to use removeByName method
            msg: "Buy Price cannot be less than 0, please input the Buy Price of the stock", // Toast Message
            type: "error", // Toast type,
            position: "toast-top-full-width",
            clickClose: true, // Click Close Disable
            timeout: 0,
            showCloseButton:true,
          });
        }
        return true;
      }
    },

    reset() {
      /* if (!isTokenValid()) {
        this.logout(this.sessionIdleErrorMsg);
        return;
      } */

      this.cash = 0;
      this.holdingsJson = [];
      this.suggestions = [];
      this.fileUploadBtnTxt = "Import Holdings";
      const files = this.$refs.importHoldings.files;
      this.$refs.importHoldings.value = "";

      this.$toastr.removeByName('symbol-error');
      this.$toastr.removeByName('quantity-error');
      this.$toastr.removeByName('price-error');

      this.holdingsJson.forEach(function(obj,index) {
        $(`#${index+1}Symbol`).removeClass('errorCellClass');
        $(`#${index+1}BuyDate`).removeClass('errorCellClass');
      });

      this.setAlphaScopeData(null);
      this.setPortfolio(null);

      this.validateHoldings();
      this.showGenerateReportButton=false;
    },

    changePortfolio(event) {
      this.selectedPortfolioId = event;
      for (var i in this.portfo)
        if (this.portfo[i].id === event)
          this.brokerOrModelForPortfolio = this.portfo[i].name;
    },

    changeRecomm(event) {
      this.selectedRecommId = event;
      for (var i in this.reco)
        if (this.reco[i].id === event)
          this.brokerOrModelForRecomm = this.reco[i].name;
    },

    changeTradeType(index, event, key) {
      if (
        this.holdingsJson[index][key] != "" &&
        this.holdingsJson[index][key] != undefined &&
        this.holdingsJson[index][key] != null
      ) {
        if (event.target.value == "1") {
          if (key == "Quantity" && this.holdingsJson[index][key].includes("-")) {
            this.holdingsJson[index][key] = ""
            this.holdingsJson[index][key] = `${event.target.value}`;
          }else {
            this.holdingsJson[index][key] = `-${this.holdingsJson[index]["Quantity"]}`;
          }
        } else {
          this.holdingsJson[index][key] = this.holdingsJson[index][key].replace(
            "-",
            ""
          );
        }
      } else {
        this.$toastr.e(
          "Please add a valid Quantity before changing the Trade Type"
        );
        return false;
      }
    },

    logout(msg) {
      //this.$router.push({ name: "Logout" });
      this.$toastr.e(msg);
    },

    downloadSample() {
      /* if (!isTokenValid()) {
        this.logout(this.sessionIdleErrorMsg);
        return;
      } */
      document.querySelector("#alpha-btn").click();
    },

    changebroker(e) {
      this.selectedBroker = e;
    },

    downloadTransaction(type) {
      /* if (!isTokenValid()) {
        this.logout(this.sessionIdleErrorMsg);
        return;
      } */
      document.querySelector("#"+type).click();
    },

    downloadSampleReport() {
     /*  if (!isTokenValid()) {
        this.logout(this.sessionIdleErrorMsg);
        return;
      } */
      this.$refs.downloadSampleReport.click();
      // document.querySelector("#downloadSampleReport").click();
    },

    addNewRow() {
      //  if(this.holdingsJson.length===100){
      //   this.$toastr.e("Maximum numbers of rows allowed per portfolio is 100");
      //   return;
      // }

      /* if (!isTokenValid()) {
        this.logout(this.sessionIdleErrorMsg);
        return;
      } */
      if (this.validateHoldings() === true) {
        this.holdingsJson.push({
          Symbol: "",
          Quantity: "",
          BuyDate: "",
          BuyPrice: "",
          SlNo: this.holdingsJson.length + 1,
        });
      }
      this.validTable = false;
      this.validRow = false;
    },

    updateJson: debounce( function(index, event, key) {
      if (key == "Quantity" && this.holdingsJson[index][key].includes("-")) {
        this.holdingsJson[index][key] = ""
        this.holdingsJson[index][key] = `${event.target.value}`;
      } else {
        this.holdingsJson[index][key] = event.target.value;
      }
      if (key != "Symbol") {
        this.suggestions = [];
        this.doAutoSuggest = false;
        this.symIndex = "";
      } else {
        this.doAutoSuggest = true;
        this.symIndex = index;
        $(`#${index+1}Symbol`).removeClass('errorCellClass')
      }
      if(key == 'BuyDate')
      {
        $(`#${index+1}BuyDate`).removeClass('errorCellClass');
      }
      let validateSymbol = !this.validateSymbol(
        this.holdingsJson[index]["Symbol"],
        index,
        false
      );
      let validatePrice = !this.validatePrice(
        this.holdingsJson[index]["BuyPrice"],
        index,
        false
      );
      let validateQuantity = !this.validateQuantity(
        this.holdingsJson[index]["Quantity"],
        index,
        false
      );
      let validDate = this.holdingsJson[index]["BuyDate"] != "";

      if (key == "Symbol") {
        this.validRow =
          !this.validateSymbol(this.holdingsJson[index][key], index) &&
          validatePrice &&
          validateQuantity &&
          validDate;
        // this.validTable =
        //   !this.validateSymbol(this.holdingsJson[index][key], index) &&
        //   validatePrice &&
        //   validateQuantity &&
        //   validDate;
      }
      if (key == "BuyPrice") {
        this.validRow =
          !this.validatePrice(this.holdingsJson[index][key], index) &&
          validateSymbol &&
          validateQuantity &&
          validDate;
        // this.validTable =
        //   !this.validatePrice(this.holdingsJson[index][key], index) &&
        //   validateSymbol &&
        //   validateQuantity &&
        //   validDate;
      }
      if (key == "Quantity") {
        this.validRow =
          !this.validateQuantity(this.holdingsJson[index][key], index) &&
          validateSymbol &&
          validatePrice &&
          validDate;
        // this.validTable =
        //   !this.validateQuantity(this.holdingsJson[index][key], index) &&
        //   validateSymbol &&
        //   validatePrice &&
        //   validDate;
      }
      this.validTable = this.validateHoldings();
    }, 500),

    updateBuyDate(index, value) {
      let validateSymbol = !this.validateSymbol(
        this.holdingsJson[index]["Symbol"],
        index,
        false
      );
      let validatePrice = !this.validatePrice(
        this.holdingsJson[index]["BuyPrice"],
        index,
        false
      );
      let validateQuantity = !this.validateQuantity(
        this.holdingsJson[index]["Quantity"],
        index,
        false
      );

      if (
        moment(moment(value).utcOffset("+05:30").format("YYYY-MM-DD"), "YYYY-MM-DD", true).isValid()
      ) {
        let val = moment(value).utcOffset("+05:30").format("YYYY-MM-DD");
        this.holdingsJson[index]["BuyDate"] = val;
        this.updatePriceByDate(index, val);
        this.validRow =
          true && validateSymbol && validatePrice && validateQuantity;
        this.validTable = this.validateHoldings();
      } else {
        this.$toastr.removeByType("error");
        var priceError = this.$toastr.Add({
          name: "price-error", // this is give you ability to use removeByName method
          msg: "Purchase Date & Buy Price is Mandatory", // Toast Message
          type: "error", // Toast type,
          position: "toast-top-full-width",
          clickClose: true, // Click Close Disable
          timeout: 0,
          showCloseButton:true,
        });
        this.holdingsJson[index]["BuyPrice"] = "";
        this.validRow = false;
        this.validTable = false;
      }
      this.suggestions = [];
      this.doAutoSuggest = false;
    },

    updatePriceByDate(index, date) {
      let instIndex = this.holdingsJson[index]["Symbol"];
      if (this.instrumentsJson[instIndex] != undefined) {
        let instrumentId = this.instrumentsJson[instIndex];
        this.getPriceAPI(index, date, instrumentId);
      } else {
        if (instIndex != "" && instIndex != null) {
          this.getInstId(index, date);
        } else {
          this.holdingsJson[index]["BuyPrice"] = "";
          this.validateHoldings();
        }
      }
      this.suggestions = [];
    },

    async getPriceAPI(index, date, instrumentId) {
      if (instrumentId !== "") {
        date = moment(date, "YYYY-MM-DD")
          .utcOffset("+05:30")
          .format("DD/MM/YYYY");
        await this.getSymbolPrice(
            this.msUrl +
              "getPriceForSymbol.json?instId=" +
              instrumentId +
              "&transDate=" +
              date +
              "&splitAdjust=" +
              "&" +
              this.msAuth
          )
          .then(response => {
            if (!response.data && response.data.status != 200) {
              //this.$toastr.e('Upload failed. Please check your CSV file and then try again.');
              this.$toastr.e(
                "Unable to retrieve price, kindly enter manually."
              );
            } else {
              this.holdingsJson[index]["BuyPrice"] = response.data.Price;
              this.validateHoldings();
              return response;
            }
          });
      } else {
        this.holdingsJson[index]["BuyPrice"] = "";
        this.$toastr.e("Unable to retrieve price, kindly enter manually.");
      }
      this.suggestions = [];
    },

    async getInstId(index, date) {
      let curSymbol = this.holdingsJson[index]["Symbol"];
      await this.getInstrumentId(
          this.msUrl +
            "srch.json?text=" +
            curSymbol +
            "&lang=en&listID=-1&ver=2&" +
            this.msAuth
        )
        .then(response => {
          let instrumentId = "";
          if (response.data.response.results.length > 0) {
            instrumentId = response.data.response.results[0].instrumentId;
          }
          this.getPriceAPI(index, date, instrumentId);
        });
      this.suggestions = [];
    },

    deleteRow(index) {
      this.holdingsJson.splice(index, 1);
      this.holdingsJson.forEach(function(obj,indexx) {
      obj.SlNo = indexx+1;
      $(`#${indexx+1}Symbol`).removeClass('errorCellClass');
      $(`#${indexx+1}BuyDate`).removeClass('errorCellClass');

              });
      this.validateHoldings();
      this.showGenerateReportButton = false
    },

    previewImportHoldingsFiles() {
      // if (!isTokenValid()) {
      //   this.logout(this.sessionIdleErrorMsg);
      //   return;
      // }
      if (this.$refs.importHoldings.files.length > 0) {
        this.userPortfolioFiles = this.$refs.importHoldings.files;
        if (this.userPortfolioFiles[0].name != null) {
          this.fileUploadBtnTxt = this.userPortfolioFiles[0].name;
          //$('#ShowAlphaScope').removeClass('disabled');
        }
        if (window.FileReader) {
          var results = this.getText(this.userPortfolioFiles[0]);
          $(".newRows").remove();
        } else {
          alert("FileReader are not supported in this browser.");
        }
      }
    },

    previewImportTransaction() {
      // if (!isTokenValid()) {
      //   this.logout(this.sessionIdleErrorMsg);
      //   return;
      // }
      this.transactionfile = this.$refs.importTransactions.files[0];
      if (this.$refs.importTransactions.files[0].name != null) {
        this.transactionBtnText = this.transactionfile.name;
        this.showdeletefilebtn = true
        this.showSubmitBtn = true;
      }
    },

    deleteselectedfile(){
      this.$refs.importTransactions.value = "";
      this.transactionBtnText = "Choose File";
      this.showdeletefilebtn = false;
      this.showSubmitBtn = false;
    },


    submitTransaction() {
      this.transactionBtnText = "Choose File";
      if (this.$refs.importTransactions.files.length > 0) {
        if (window.FileReader) {
          var reader = new FileReader();
          this.rABS = !reader.readAsBinaryString;
          if (this.transactionfile.name.includes(".csv") ||
            this.transactionfile.name.includes(".CSV")) {
            reader.readAsText(this.transactionfile);
            reader.onload = this.loadCSVHandler;
          } else if (
            this.transactionfile.name.includes(".xlsx") ||
            this.transactionfile.name.includes(".xls")
          ) {
            if (this.rABS) reader.readAsBinaryString(this.transactionfile);
            else reader.readAsArrayBuffer(this.transactionfile);
            reader.onload = this.loadTransactionHandler;
          } else {
            this.$toastr.e("File type not supported.");
          }

          reader.onerror = this.errorHandler;
        }
      } else {
        alert("FileReader are not supported in this browser.");
      }
    },

    getText(fileToRead) {
      var reader = new FileReader();
      reader.readAsText(fileToRead);
      reader.onload = this.loadHandler;
      reader.onerror = this.errorHandler;
    },

    loadCSVHandler(event) {
      let columnIndex = {
        Symbol: null,
        Quantity: null,
        BuyDate: null,
        BuyPrice: null
      };
      var csv = event.target.result;
      var lines = csv.split("\n");
      var a = [];
      var data = [];
      let startRow = null;
      let formatError  = false;
      lines.forEach(element => {
        data.push(element.split(","));
      });
      data.pop();
      this.cancelModal();

      switch (this.selectedBroker) {
        // case 1:
        //   startRow = 4;
        //   columnIndex.Symbol = 0;
        //   columnIndex.Quantity = 4;
        //   columnIndex.BuyDate = 2;
        //   columnIndex.BuyPrice = 5;
        //   break;
        // case 2:
        //   startRow = 1;
        //  columnIndex.Symbol = 1;
        //   columnIndex.Quantity = 3;
        //   columnIndex.BuyDate = 0;
        //   columnIndex.BuyPrice = 4;
        //   break;
        // case 3:
        //   startRow = 3;
        //   columnIndex.Symbol = 0;
        //   columnIndex.Quantity = 1;
        //   columnIndex.BuyDate = 2;
        //   columnIndex.BuyPrice = 4;
        //   break;
        case 4:
          startRow = 1;
          columnIndex.Symbol = data[0].indexOf('symbol');
          columnIndex.Quantity = data[0].indexOf('quantity');
          columnIndex.BuyDate = data[0].indexOf('trade_date');
          columnIndex.BuyPrice = data[0].indexOf('price');
          columnIndex.TradeType = data[0].indexOf('trade_type');
          break;

        case 5:
          startRow = 1;
          columnIndex.Symbol = data[0].indexOf('Symbol');
          columnIndex.Quantity = data[0].indexOf('Quantity');
          columnIndex.BuyDate = data[0].indexOf('BuyDate');
          columnIndex.BuyPrice = data[0].indexOf('BuyPrice');
          columnIndex.TradeType = data[0].indexOf('Type');
          break;
        default:
      }
      formatError = Object.values(columnIndex).includes(-1)
      if(formatError) {
        this.$toastr.e(
          "The file is different from the expected format. Please see the sample file headers and upload accordingly."
        );
      }
      if(!formatError) {
        for (var i = startRow; i < data.length; i++) {
          const {Symbol, Quantity, BuyDate, BuyPrice} = columnIndex;
          let p = {Symbol: "", Quantity: "", BuyDate: "", BuyPrice: "", SlNo: i};
          let str = data[i][Symbol] === undefined ? "" : data[i][Symbol].toString();
          p.Symbol = str.trim();
          p.Quantity = this.formatQuantity(data[i], Quantity);
          p.BuyDate = this.formatDate(data[i][BuyDate]);
          p.BuyPrice = data[i][BuyPrice] === undefined ? "" : data[i][BuyPrice].toString();
          a.push(p);
        }
        this.showImportTransactions = false;
        this.holdingsJson = a;
        this.holdingsJsonCount = this.holdingsJson.length;
        this.validateHoldings(true);
        this.selectedBroker = 5;
        this.$refs.importTransactions.value = "";
        this.showGenerateReportButton = true;
      }
    },

    loadTransactionHandler(event) {
      const reader = new FileReader();
      const bstr = event.target.result;
      const wb = XLSX.read(bstr, { type: this.rABS ? "binary" : "array" });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_row_object_array(ws, { header: 1 });
      this.processTransaction(data);
    },

    processTransaction(transactions) {
      this.cancelModal();
      this.$toastr.removeByName('symbol-error');
      this.$toastr.removeByName('quantity-error');
      this.$toastr.removeByName('price-error');
      this.holdingsJson.forEach(function(obj,index) {
        $(`#${index+1}Symbol`).removeClass('errorCellClass');
        $(`#${index+1}BuyDate`).removeClass('errorCellClass');
      });
      let data = transactions.filter(function(el) {
        return el !== [];
      });
      let formattedData = [];
      let a = [];
      let startRow = null;
      let columnIndex = {
        Symbol: null,
        Quantity: null,
        BuyDate: null,
        BuyPrice: null
      };
      let formatError  = false;
      switch (this.selectedBroker) {
        // case 1:
        //   startRow = 4;
        //   columnIndex.Symbol = 3;
        //   columnIndex.Quantity = 8;
        //   columnIndex.BuyDate = 2;
        //   columnIndex.BuyPrice = 10;
        //   break;
        // case 2:
        //   startRow = 1;
        //   columnIndex.Symbol = 1;
        //   columnIndex.Quantity = 3;
        //   columnIndex.BuyDate = 0;
        //   columnIndex.BuyPrice = 4;
        //   break;
        // case 3:
        //   startRow = 3;
        //   columnIndex.Symbol = 0;
        //   columnIndex.Quantity = 1;
        //   columnIndex.BuyDate = 2;
        //   columnIndex.BuyPrice = 4;
        //   break;
        case 4:
          startRow = 15;
          columnIndex.Symbol = data[14].indexOf('Symbol');
          columnIndex.Quantity = data[14].indexOf('Quantity');
          columnIndex.BuyDate = data[14].indexOf('Trade Date');
          columnIndex.BuyPrice = data[14].indexOf('Price');
          columnIndex.TradeType = data[14].indexOf('Trade Type');
          break;
        case 5:
          startRow = 1;
          columnIndex.Symbol = data[0].indexOf('Symbol');
          columnIndex.Quantity = data[0].indexOf('Quantity');
          columnIndex.BuyDate = data[0].indexOf('BuyDate');
          columnIndex.BuyPrice = data[0].indexOf('BuyPrice');
          columnIndex.TradeType = data[0].indexOf('Type');
          break;
        default:
      }
      formatError = Object.values(columnIndex).includes(-1)
      if(formatError) {
        this.$toastr.e(
          "The file is different from the expected format. Please see the sample file headers and upload accordingly."
        );
      }

      const zeroQuantityRows = data.filter(row => {
        const quantityIndex = columnIndex.Quantity;
        return row[quantityIndex] === 0 || row[quantityIndex] === '0';
      });

      if (zeroQuantityRows.length > 0) {
        this.$toastr.e(
          "Some rows have a Quantity of zero. Please correct these rows and try again."
        );
        formatError = true;
      }

      if(!formatError) {
        for (var i = startRow; i < data.length; i++) {
          const {Symbol, Quantity, BuyDate, BuyPrice} = columnIndex;
          let p = {Symbol: "", Quantity: "", BuyDate: "", BuyPrice: "", SlNo: i};
          if (data[i].length > 0) {
            const symbolModified = data[i][Symbol] === undefined ? "" : data[i][Symbol].toString();
            p.Symbol = symbolModified.trim();
            p.Quantity = this.formatQuantity(data[i], Quantity);
            p.BuyDate = this.formatDate(data[i][BuyDate]);
            p.BuyPrice = data[i][BuyPrice] === undefined ? "" : data[i][BuyPrice].toString();
            a.push(p);
          }
        }

        this.showImportTransactions = false;
        this.holdingsJson = a;
        this.holdingsJsonCount = this.holdingsJson.length;
        this.validateHoldings(true);
        this.selectedBroker = 5;
        this.$refs.importTransactions.value = "";
        this.showGenerateReportButton = true;
        // this.sendTransactionData(a);
      }
    },

    sendTransactionData(data) {
      const loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      this.$refs.importTransactions.value = "";
      this.showSubmitBtn = false;
      this.showdeletefilebtn = false;
      const formData = new FormData();
      formData.append("transaction_data", JSON.stringify(data));
      this.$http
        .post(API_URL + "holdings_from_transactions", formData, {
          headers: {
            Authorization: `Basic ${btoa(
              unescape(
                encodeURIComponent(
                  `${localStorage.getItem("access_token")}:` + ""
                )
              )
            )}`
          }
        })
        .then(response => {
          loader.hide();
          // Session Expired
          if (response.status === 401) {
            /* this.$router.push({
              name: "Logout"
            }); */
          }
          if (!response.data && response.data.status != 200) {
            this.$toastr.e(
              "Upload failed. Please check your transactions file and then try again."
            );
          } else {
            var self = this;
            this.reset();
            if (response.data) {
              this.transactionData.BestExclusions =
                response.data[0].BestExclusions;
              this.transactionData.BestWinners = response.data[0].BestWinners;
              this.transactionData.WorstExclusions =
                response.data[0].WorstExclusions;
              this.transactionData.WorstLosers = response.data[0].WorstLosers;
              this.setTransactionData(this.transactionData);
            }
            response.data &&
              response.data[0].InputData.forEach(function(obj) {
                obj.BuyDate = moment(obj.PriceDate).format("YYYY-MM-DD");
                self.holdingsJson.push(obj);
              });
            this.holdingsJsonCount = this.holdingsJson.length;
            this.validateHoldings(true);
          }
        })
        .catch(e => {
          //   loader.hide();
          loader.hide();
          if (e.response.status === 401) {
            // Session Expired
            /* this.$router.push({
              name: "Logout"
            }); */
            this.$toastr.e(
              "An unknown error occured. Please try again, or contact a developer for assistance."
            );
          } else if (e.response.status === 400) {
            // Wrong File
            this.$toastr.e(
              "Incorrect data, Please upload CSV File as sample file."
            );
          } else {
            /* this.$router.push({
              name: "Logout"
            }); */
            this.$toastr.e(
              "An unknown error occured.Please try again, or contact a developer for assistance."
            );
          }
        });
    },

    formatDate(date) {
      if (this.selectedBroker == 1) {
        return moment(date).utcOffset("+05:30").format("YYYY-MM-DD");
      } else if (this.selectedBroker == 2) {
        return moment(this.julianIntToDate(date)).utcOffset("+05:30").format("YYYY-MM-DD");
      } else if (this.selectedBroker == 4) {
        return moment(date).utcOffset("+05:30").format("YYYY-MM-DD");
      } else if (this.selectedBroker == 5) {
        return moment(this.excelDateToJSDate(date)).utcOffset("+05:30").format("YYYY-MM-DD");
      }
      return date;
    },

    excelDateToJSDate(serial) {
      var utc_days = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);
      var fractional_day = serial - Math.floor(serial) + 0.0000001;
      var total_seconds = Math.floor(86400 * fractional_day);
      var seconds = total_seconds % 60;
      total_seconds -= seconds;

      var hours = Math.floor(total_seconds / (60 * 60));
      var minutes = Math.floor(total_seconds / 60) % 60;

      return new Date(
        date_info.getFullYear(),
        date_info.getMonth(),
        date_info.getDate(),
        hours,
        minutes,
        seconds
      );
    },

    formatQuantity(row, index) {
      row[2]=row[2]===undefined?"":row[2];
      row[4]=row[4]===undefined?"":row[4];
      row[5]=row[5]===undefined?"":row[5];
      row[6]=row[6]===undefined?"":row[6];
      let quantity = `${row[index]}`;
      if (this.selectedBroker == 2) {
        quantity = `${row[2].toLowerCase() == "sell" ? "-" : ""}${row[index]}`;
      } else if (this.selectedBroker == 1) {
        quantity = `${row[9] == 0 ? "-" : ""}${row[index]}`;
      } else if (this.selectedBroker == 4) {
        if (this.transactionfile.name.includes(".csv")) {
          quantity = `${row[6].toLowerCase() == "sell" ? "-" : ""}${
            Math.trunc(row[index])
          }`;
        } else {
          quantity = `${row[6].toLowerCase() == "sell" ? "-" : ""}${
            Math.trunc(row[index])
          }`;
        }
      } else if (this.selectedBroker == 5) {
        quantity = `${row[4].toLowerCase() == "sell" ? "-" : ""}${Math.trunc(row[index])}`;
      } else {
        quantity = `${Math.trunc(row[index])}`;
      }
      return quantity;
    },

    julianIntToDate(jd) {
      return moment("01.01.1900", "DD-MM-YYYY")
        .add(parseInt(jd) - 2, "days")
        .format("YYYY-MM-DD");
    },

    loadHandler(event) {
      var csv = event.target.result;
      this.process(csv);
    },

    cancelModal(action) {
      // this.selectedBroker = null;
      // this.$refs.importTransactions.value = "";
      this.showSubmitBtn = false;
      this.showdeletefilebtn = false;
      this.showShortSellError = false;
      this.transactionBtnText = "Choose File";
      this.showTransaction = false;
      this.showConfirmationPopup = false;
      this.allowShortSell=0
    },

    allowShortSellAction(action){
      this.allowShortSell=1
      this.submit();
    },

    process(csv) {
      // Newline split
      var lines = csv.split("\n");
      var headers = ["Symbol", "Quantity", "BuyDate", "BuyPrice"];
      this.holdingsJson = [];

      var max = 0;
      if (lines.length <= 2) {
        max = lines.length;
      } else {
        max = lines.length - 1;
      }

      for (var i = 1; i < max; i++) {
        var obj = {};

        //Comma split
        var currentline = lines[i].split(",");
        for (var j = 0; j < headers.length; j++) {
          if (currentline[j] === undefined) {
            currentline[j] = "";
          }
          if (headers[j] == "BuyDate") {
            if (currentline[j] === undefined || currentline[j] == "") {
              currentline[j] = "";
            } else {
              currentline[j] = this.dateDMYtoYMD(currentline[j]);
            }
          }
          obj[headers[j]] = currentline[j];
        }
        this.holdingsJson.push(obj);
        this.holdingsJsonCount = this.holdingsJson.length;
        this.validateHoldings(true);
      }
    },

    errorHandler(evt) {
      if (evt.target.error.name == "NotReadableError") {
        alert("Cannot read your file !");
      }
    },

    async submit() {
      this.$toastr.removeByName('symbol-error');
      this.$toastr.removeByName('quantity-error');
      this.$toastr.removeByName('price-error');
      this.holdingsJson.forEach(function(obj,index) {
        $(`#${index+1}Symbol`).removeClass('errorCellClass');
        $(`#${index+1}BuyDate`).removeClass('errorCellClass');
      });


      this.$v.$touch();
      if (this.$v.invalid) {
        return;
      }

      //if (userPortfolioCSV.files[0] != undefined) {
      if (this.holdingsJson.length > 0) {
        const loader = this.$loading.show({
          // Optional parameters
          container: this.$refs.formContainer,
          canCancel: true,
          onCancel: this.onCancel
        });

        this.holdingsJson = _.each(this.holdingsJson, function(o) {
          _.each(o, function(v, k) {
            if (k === "BuyPrice") {
              v = v.toString();
            }
            o[k] = typeof v == "string" ? v.trim() : v;
          });
        });
        /* this.$toastr.Add({
                   name: "loadingAlert", // this is give you ability to use removeByName method
                   msg:"Please stay put while our system generates your report. This will take few mins as it involves a lot of calculations and in-depth analysis",
                   type: "info", // Toast type,
                   position: "toast-top-full-width",
                   clickClose: true, // Click Close Disable
                   timeout: 0,
                   showCloseButton:true,
                }); */
        const formData = new FormData();
        formData.append(
          "user_portfolio_data",
          JSON.stringify(this.holdingsJson)
        );
        formData.append("portfolio_id", this.selectedPortfolioId);
        formData.append("rec_id", this.selectedRecommId);
        formData.append("cash", this.cash);
        formData.append("allowShortSell", this.allowShortSell);
        saveJWTToStorage("preLoginHoldingsData",JSON.stringify(this.holdingsJson));
        if (this.isRedirectedGuestBrokerUrl) {
          this.$router.replace('/login/signup');
        }
        else {
          this.$router.replace('/login/login?next=/evaluation');
        }
      }
    },

    showOldReport() {
      this.setEnableReport(true);
    },

    onCancel() {
    },

    checkCellError(type,value) {
       if(type==='price')
       {
         if(value===""||value==="undefined")
         return true
         else
         {
          return false;
         }

       }
       else if(type==='quantity')
       {
         if(value===""||value==="undefined" || value === null || isNaN(value) || Number(value) === 0)
         return true
         else
         {
          return false;
         }
       }
      else if(type==='symbol')
       {
         if(value===""||value==="undefined")
         return true
         else
         {
          return false;
         }
       }
       else if(type==='buyDate')
       {
         if(value===""||value==="undefined")
         return true;
         else
         {
          return false;
         }
       }
       else
         {
          return false;
         }
    },
    getTextBoxId(index,type)
    {
      if(type==="Symbol")
       return `${index + 1}Symbol`;
      else if(type==="BuyDate")
       return `${index + 1}BuyDate`
    },

    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      // disable days that fall on the 13th of the month
      const weekday = date.getDay()
      const day = date.getDate()
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/preevaluation.js